module.exports = __webpack_public_path__ + "static/media/recept-3.f29422a4.jpg";